/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
export const HOME = "/"

export const LOGIN = "/login"
export const LOGIN_SUCCESS = "/login-success"

export const LOGOUT = "/profile/logout"

export const OUTLET = (storeID?: StoreID): string => {
  if (storeID) {
    return `/food/stores/${storeID}`
  }
  return `/food/stores/:storeID`
}

export const OUTLET_ORDERS = (
  storeID = ":storeID",
  longOrderID = ":longOrderID",
): string => `/food/stores/${storeID}/orders/${longOrderID}`

export const OUTLET_TRANSACTIONS = (
  storeID = ":storeID",
  transactionID = ":txnID",
): string => `/food/stores/${storeID}/transactions/${transactionID}`

export const OUTLET_OVO_TRANSACTIONS = (
  storeID = ":storeID",
  transactionID = ":txnID",
): string => `/food/stores/${storeID}/ovoTransactions/${transactionID}`

export const OUTLET_BOOKING_ID_PATTERN = new RegExp("bookingID=([\\w-]+)")

export const OUTLET_PATTERN = new RegExp("/food/stores/?")

export const OUTLET_ORDERS_PATTERN = new RegExp(
  "/food/stores/([\\w-]+)/orders/([\\w-]+)",
)
export const OUTLET_TRANSACTIONS_PATTERN = new RegExp(
  "/food/stores/([\\w-]+)/transactions/([\\w-]+)",
)

export const OUTLET_OVO_TRANSACTIONS_PATTERN = new RegExp(
  `/food/stores/([\\w-]+)/ovoTransactions/([\\w-]+)`,
)

export const CHAIN = (): string => {
  return `/food/merchant`
}

export const CHAIN_PATTERN = new RegExp("/food/merchant/?")

export const MME_URL_PREFIX = `/food`

export const MENUS = `${MME_URL_PREFIX}/menu`

export const MENU_DETAIL_PATTERN = new RegExp(`${MENUS}/(.*\\S.*)`)

export const CATALOGUES = `${MME_URL_PREFIX}/catalogue`

export const CATALOGUE_DETAIL_PATTERN = new RegExp(`${CATALOGUES}/(.*\\S.*)`)

export const CREATE_MENU = `${MME_URL_PREFIX}/create-menu`
export const CREATE_CATALOGUE = `${MME_URL_PREFIX}/create-catalogue`
export const INVENTORY = `${MME_URL_PREFIX}/inventory`

export const FEEDBACK = `/feedback`

interface MenuDetailParams {
  isMartStore?: boolean
  merchantID?: string
  tabKey?: string
  itemID?: string
  customRoutePrefix?: string
}

export const MENU_DETAIL = ({
  isMartStore = false,
  merchantID = ":merchantID",
  tabKey = ":tabKey",
  itemID = ":itemID",
  customRoutePrefix,
}: MenuDetailParams): string => {
  let prefix = MENUS
  if (isMartStore) prefix = CATALOGUES
  if (customRoutePrefix) prefix = customRoutePrefix
  return `${prefix}/${merchantID}/${tabKey}/${itemID}`
}

// ~ORDER MANAGER~ <-- use this pattern to find order manager related code outside it's main directory (for code migration purpose)
export const ORDER_MANAGER_URL_PREFIX = "/order"

// ~ORDER MANAGER~ <-- use this pattern to find order manager related code outside it's main directory (for code migration purpose)
export const ORDER_MANAGER_URL_PATTERN = new RegExp(
  `${ORDER_MANAGER_URL_PREFIX}/(.*\\S.*)`,
)

const LOGIN_REDIRECT_URL = encodeURIComponent(
  `https://${window.location.host}${LOGIN_SUCCESS}`,
)

/**
 * only used for local development
 */
export const STG_WEB_LOGIN_URL = `https://weblogin.stg-myteksi.com/merchant/login?service_id=MEXUSERS&ui_locales=en&redirect=${LOGIN_REDIRECT_URL}`
